import React, { useEffect, useState } from "react";
import { Mail, Phone, Home } from "lucide-react";
import api from "../../api";
import MyProperties from "../../components/MyProperties";

const STATUSES = ["new", "contacted", "closed"];

function Leads() {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/leads");
      setLeads(data.leads);
    } catch (e) {}
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => { await api.put(`/leads/${id}`, { status }); load(); };

  if (loading) return <p className="text-neutral-500 py-10 text-center">Loading leads…</p>;
  if (leads.length === 0)
    return (
      <div className="text-center py-16 border border-dashed border-neutral-300 rounded-2xl" data-testid="no-leads">
        <p className="text-neutral-500">No leads yet. Enquiries on your listings appear here.</p>
      </div>
    );

  return (
    <div className="grid gap-4" data-testid="leads-list">
      {leads.map((l) => (
        <div key={l.id} className="bg-surface border border-neutral-200 shadow-card rounded-2xl p-5" data-testid={`lead-${l.id}`}>
          <div className="flex flex-wrap items-center justify-between gap-3">
            <div>
              <p className="font-semibold text-neutral-900">{l.name}</p>
              {l.property_title && <p className="text-neutral-500 text-sm flex items-center gap-1"><Home className="w-3.5 h-3.5" /> {l.property_title}</p>}
            </div>
            <select value={l.status} onChange={(e) => setStatus(l.id, e.target.value)} data-testid={`lead-status-${l.id}`}
              className="bg-neutral-50 border border-neutral-200 rounded-lg px-3 py-1.5 text-sm capitalize focus:outline-none focus:border-brand-500">
              {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>
          <div className="flex flex-wrap gap-4 mt-3 text-sm text-neutral-600">
            <span className="flex items-center gap-1"><Mail className="w-4 h-4 text-brand-500" /> {l.email}</span>
            <span className="flex items-center gap-1"><Phone className="w-4 h-4 text-brand-500" /> {l.phone}</span>
          </div>
          {l.message && <p className="text-neutral-500 text-sm mt-2 italic">"{l.message}"</p>}
        </div>
      ))}
    </div>
  );
}

export default function AgentDashboard() {
  const [tab, setTab] = useState("listings");
  return (
    <div data-testid="agent-dashboard">
      <div className="flex gap-2 mb-8">
        {[["listings", "My Listings"], ["leads", "Leads"]].map(([id, label]) => (
          <button key={id} onClick={() => setTab(id)} data-testid={`agent-tab-${id}`}
            className={`px-5 py-2.5 rounded-xl font-medium transition-colors ${
              tab === id ? "bg-brand-500 text-white" : "bg-surface border border-neutral-200 text-neutral-600 hover:text-neutral-900"
            }`}>
            {label}
          </button>
        ))}
      </div>
      {tab === "listings" ? <MyProperties /> : <Leads />}
    </div>
  );
}
